import { SVGGeneratorProps } from '@lessonup/teaching-core';
import React from 'react';
import { BaseMathComponent } from './BaseMathComponent';

export const HexagonComponent: React.FC<SVGGeneratorProps> = ({ position, settings }) => {
  return <BaseMathComponent position={position} settings={settings} pathFunc={hexagonPath} />;
};

function hexagonPath(width_: number, height_: number, margin_: number): string {
  // Use width and height to draw the path while taking the margin/stroke-size into account
  const margin = margin_ / 2; // Only half of the stroke size will fall outside of the path to devide by 2
  const width = width_ - margin;
  const height = height_ - margin;

  // x and y values are for the coordinates that we need in the path
  const xValues = [margin, 0.25 * width + margin, 0.75 * width + margin, 1 * width + margin];
  const yValues = [0.0625 * height + margin, 0.5 * height + margin, 0.9375 * height + margin];

  const path = `M${xValues[0]} ${yValues[1]}
     L${xValues[1]} ${yValues[2]}
     L${xValues[2]} ${yValues[2]}
     L${xValues[3]} ${yValues[1]}
     L${xValues[2]} ${yValues[0]}
     L${xValues[1]} ${yValues[0]}
     Z`;
  return path;
}
